import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { Alert } from '../data/alert';
import { TransactionResult } from '../data/transaction-result';

@Injectable({
  providedIn: 'root'
})
export class MessageManagementService {
  public alerts: BehaviorSubject<Alert[]> = new BehaviorSubject([]);
  constructor(
    private toastr: NbToastrService,
    private translateService: TranslateService
  ) {

  }

  /**
   * Method used to manage the messages in the system, this validates the type of the message and identifies if should be stored (local storage) or not.
   * @param alert Class that contains all the charasteritics of the message
   */
  public addAlert(alert: Alert, translate?: boolean, screen?: string) {


    alert.date = new Date();

    const getAlerts = this.alerts.value;
    getAlerts.push(alert);
    this.alerts.next(getAlerts);
    if (alert.title.toUpperCase().trim() == "SUCCESS") {
      alert.title = "OK";
      if (alert.shown) {
        if (translate) {
          alert.message = this.translateService.instant(screen + "." + alert.message);
          this.toastr.success(alert.message, alert.title);
        } else {
          this.toastr.success(alert.message, alert.title);
        }
      }
    }
    if (alert.title.toUpperCase().trim() == "ERROR") {
      if (null == alert.message && null != alert.messages) {
        alert.message = this.translateService.instant("ERRORS.GENERIC_WITH_LIST");
      } else if (null == alert.message) {
        alert.message = this.translateService.instant("ERRORS.GENERIC");
      }

      if (alert.shown) {
        if (translate) {
          alert.message = this.translateService.instant(screen + "." + alert.message);
          this.toastr.danger(alert.message, alert.title);
        } else {
          this.toastr.danger(alert.message, alert.title);
        }
      }
    }
    if (alert.title.toUpperCase().trim() == "WARNING") {
      alert.title = "ALERTA";
      if (alert.shown) {
        if (translate) {
          alert.message = this.translateService.instant(screen + "." + alert.message);
          this.toastr.warning(alert.message, alert.title);
        } else {
          this.toastr.warning(alert.message, alert.title);
        }
      }
    }
    if (alert.title.toUpperCase().trim() == "INFO") {
      alert.title = "INFO";
      if (alert.shown) {
        if (translate) {
          alert.message = this.translateService.instant(screen + "." + alert.message);
          this.toastr.info(alert.message, alert.title);
        } else {
          this.toastr.info(alert.message, alert.title);
        }
      }
    }
    if (alert.shown) this.messageLocalStorage(alert);
  }

  messageLocalStorage(alert: Alert) {
    var messageList: Alert[] = [];
    var result = localStorage.getItem("Messages");
    if (null != result) messageList = JSON.parse(result);
    messageList.unshift(alert);
    localStorage.setItem("Messages", JSON.stringify(messageList));
  }

  public info(message: string) {
    const alert: Alert = {
      icon: '',
      message: message,
      messages: null,
      shown: true,
      title: "INFO"
    }
    this.addAlert(alert);
  }

  public error(message: string, messages?: any[]) {
    const alert: Alert = {
      icon: '',
      message: message,
      messages: messages,
      shown: true,
      title: "ERROR"
    }
    this.addAlert(alert);
  }

  public warning(message: string) {
    const alert: Alert = {
      icon: '',
      message: message,
      messages: null,
      shown: true,
      title: "WARNING"
    }
    this.addAlert(alert);
  }

  public ok(message: string) {
    const alert: Alert = {
      icon: '',
      message: message,
      messages: null,
      shown: true,
      title: "SUCCESS"
    }
    this.addAlert(alert);
  }
  /**
   * Method used to manage the Toasats
   * @param result TransactionResult
   * @param showSuccess Flag to define if success will display a toastr or not
   */
  public showMessage(result: TransactionResult<any>, showSuccess?: boolean) {

    var title = "";
    var show = true;
    if (result.success) {
      title = "SUCCESS";
      if (null != showSuccess) {
        show = showSuccess;
      }
    } else if (result.fail) {
      title = "ERROR"
    } else if (result.warning) {
      title = "WARNING"
    } else {
      title = "INFO"
    }

    const alert: Alert = {
      icon: '',
      message: result.message != null && result.message != undefined ? result.message.length > 0 ? this.translateService.instant(result.message) : result.message : result.message,
      messages: result.messages,
      shown: show,
      title: title
    }
    this.addAlert(alert);
  }
}
